import { useQuery } from "@tanstack/react-query";
import type { CatalogDelayCode } from "../../codes/models/CatalogDelayCode";
import { getDelays } from "../../codes/repositories/ConfigurationDelayRepository";

export const useDelayCodesQuery = (assetId?: number) => {
  return useQuery({
    queryKey: ["delay-codes", assetId],
    meta: { realtime: ["DEL.GetDelayCodes"] },
    queryFn: async ({ signal }) => {
      const resp = await getDelays(assetId, signal);
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as CatalogDelayCode[];
      }
      throw new Error(resp.message);
    },
    enabled: assetId !== undefined,
  });
};
